var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-xs-center" },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": 400 },
          model: {
            value: _vm.modalMensajeValidacion,
            callback: function($$v) {
              _vm.modalMensajeValidacion = $$v
            },
            expression: "modalMensajeValidacion"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-toolbar-title",
                    {
                      staticStyle: {
                        "font-size": "17px",
                        "margin-left": "10px !important"
                      }
                    },
                    [_vm._v(_vm._s(_vm.titulo))]
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c("v-card-text", [
                _c("div", { staticStyle: { width: "100%" } }, [
                  _c("div", [_vm._v(_vm._s(_vm.mensaje))]),
                  _c("div", [_vm._v(_vm._s(_vm.mensajeBot))])
                ])
              ]),
              _c(
                "v-card-text",
                [
                  _vm.href
                    ? _c(
                        "router-link",
                        {
                          staticStyle: {
                            cursor: "pointer",
                            "font-size": "13px",
                            color: "blue",
                            "text-decoration": "underline"
                          },
                          attrs: {
                            "active-class": "router-link-active",
                            to: _vm.href
                          }
                        },
                        [_vm._v(_vm._s(_vm.labelHref))]
                      )
                    : _vm._e()
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm.btnCancelar
                    ? _c(
                        "v-btn",
                        {
                          attrs: { color: "white", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.handleCancelar($event)
                            }
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "#526da5" } }, [
                            _vm._v("Cancelar")
                          ])
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "#526da5", small: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleAceptar($event)
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v("Aceptar")
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }